var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("txtDelete")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("txtOeeDelete")) + "\n        "
              ),
              _vm._l(_vm.inventories, function(inventory) {
                return _c("div", [
                  _c("span", [
                    _vm._v(
                      _vm._s(inventory.ident) + " - " + _vm._s(inventory.name)
                    )
                  ])
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.deleteSelected }
              },
              [_vm._v(_vm._s(_vm.$t("btnDelete")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }